module.exports = __webpack_public_path__ + "static/005-calculator-1760c1554e142e7300f0ba56ac7f91fe.png";